export function withRequiredMark(label) {
  if (typeof label !== 'string') return label
  const match = label.match(/^(.*?)(\s*)\*$/)
  if (!match) return label
  return (
    <>
      {match[1]}
      {match[2]}
      <span className="edvi-req" aria-hidden="true">
        *
      </span>
    </>
  )
}
